const vipMembers = [
  {
    img: 'kevin-lin.jpg',
    name: 'Kevin Lin',
    designation: 'Twitch'
  },
  {
    img: 'kun-gao.jpg',
    name: 'Kun Gao',
    designation: 'Crunchyroll'
  },
  {
    img: 'kelly-hu.jpg',
    name: 'Kelly Hu',
    designation: 'Actress'
  },
  {
    img: 'maya-rogers.jpg',
    name: 'Maya Rogers',
    designation: 'Tetris'
  },
  {
    img: 'steve-chen.jpg',
    name: 'Steve Chen',
    designation: 'YouTube'
  },
  {
    img: 'karen-gillan.jpg',
    name: 'Karen Gillan',
    designation: 'Actress'
  },
  {
    img: 'jess-lee.jpg',
    name: 'Jess Lee',
    designation: 'Sequoia Capital'
  },
  {
    img: 'collins-key.jpg',
    name: 'Collins Key',
    designation: 'Youtuber'
  },
   {
    img: 'gene-luen-yang.jpg',
    name: 'Gene Luen Yang',
    designation: 'Graphic Novelist'
  },
  {
    img: 'jane-wu.jpg',
    name: 'Jane Wu',
    designation: 'Director'
  },
  {
    img: 'adam-cheyer.jpg',
    name: 'Adam Cheyer',
    designation: 'Siri'
  },
  {
    img: 'songyee-yoon.jpg',
    name: 'Songyee Yoon',
    designation: 'NCSoft'
  },
  {
    img: 'oksana-kubushyna.jpg',
    name: 'Oksana Kubushyna',
    designation: 'Riot Games'
  },
  {
    img: 'stacy-spikes.jpg',
    name: 'Stacy Spikes',
    designation: 'MoviePass'
  },
  {
    img: 'maitreyi-ramakrishnan.jpg',
    name: 'Maitreyi Ramakrishnan',
    designation: 'Actress'
  },
  {
    img: 'alan-taylor.jpg',
    name: 'Alan Taylor',
    designation: 'Director'
  }
];

const regularMembers = [
  {
    img: 'kevin-chou.jpg',
    name: 'Kevin Chou',
    designation: 'Kabam'
  }, 
  {
    img: 'mac-reynolds.jpg',
    name: 'Mac Reynolds',
    designation: 'Imagine Dragons'
  }, 
  {
    img: 'catherine-haena-kim.jpg',
    name: 'Catherine Haena Kim',
    designation: 'Actress'
  },
  {
    img: 'janet-hsieh.jpg',
    name: 'Janet Hsieh',
    designation: 'Actress'
  },
  {
    img: 'sheri-bryant.jpg',
    name: 'Sheri Bryant',
    designation: 'Geek & Sundry'
  }, 
  {
    img: 'george-young.jpg',
    name: 'George Young',
    designation: 'Actor'
  }, 
  {
    img: 'shawn-tsao.jpg',
    name: 'Shawn Tsao',
    designation: 'Caviar'
  }, 
  {
    img: 'carolina-ravassa.jpg',
    name: 'Carolina Ravassa',
    designation: 'Actress'
  }, 
  {
    img: 'soo-lee.jpg',
    name: 'Soo Lee',
    designation: 'Artist'
  }, 

];

const membersAPI = {
  // Function to get all members (random 8 VIP + random 3 regular = 11 total)
  getAllMembers: () => {
    // Helper function to get random items from array
    const getRandomItems = (array, count) => {
      const shuffled = [...array].sort(() => 0.5 - Math.random());
      return shuffled.slice(0, Math.min(count, array.length));
    };

    // Get random 8 VIP members and random 3 regular members
    const randomVipMembers = getRandomItems(vipMembers, Math.min(8, vipMembers.length));
    const randomRegularMembers = getRandomItems(regularMembers, Math.min(3, regularMembers.length));

    // Interleave: 5 VIP, 1 regular, then alternate 1 VIP, 1 regular until exhausted
    const result = [];
    let vipIndex = 0;
    let regularIndex = 0;
    
    // Add first 5 VIP members
    for (let i = 0; i < 5 && vipIndex < randomVipMembers.length; i += 1) {
      result.push(randomVipMembers[vipIndex]);
      vipIndex += 1;
    }

    // Then alternate: 1 regular, 1 VIP, 1 regular, 1 VIP, etc.
    while (vipIndex < randomVipMembers.length || regularIndex < randomRegularMembers.length) {
      // Add 1 regular member if available
      if (regularIndex < randomRegularMembers.length) {
        result.push(randomRegularMembers[regularIndex]);
        regularIndex += 1;
      }
      
      // Add 1 VIP member if available
      if (vipIndex < randomVipMembers.length) {
        result.push(randomVipMembers[vipIndex]);
        vipIndex += 1;
      }
    }

    return result;
  },

  // Function to get a specific member by index
  getMember: (index) => {
    if (index >= 0 && index < vipMembers.length) {
      return vipMembers[index];
    }
    return null;
  }
};

export default membersAPI;